(ns frontend.view.dashboard.view
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.conn :as conn]
   [frontend.db :as db]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.view.components.timeline.view :as timeline]
   [frontend.view.dashboard.leads-home.view :as leads-home-card]
   [frontend.view.dashboard.oppos-per-status.view :as oppos-per-status-card]
   [frontend.view.dashboard.oppos-per-user.view :as oppos-per-user-card]
   [frontend.view.dashboard.passed.view :as passed-home-card]
   [frontend.view.grid.common.utils :as grid-utils]
   [frontend.view.metabase-dashboard.view :as metabase-dashboard]
   [reagent.core :as r :include-macros true]))

(defonce state (r/cursor db/app-state [:views :dashboard]))

(defn dashboard
  [data]
  [:div
   {:class-name "grid grid-cols-2 gap-4"}
   [oppos-per-user-card/component data]
   [leads-home-card/component data]
   [oppos-per-status-card/component data]
   [passed-home-card/component data]])

(defn sidebar
  [timeline-entries]
  [timeline/component
   {:timeline-entries timeline-entries
    :target-type      :dashboard
    :filters          [:op.webentry/resolve
                       :op.oppo/create
                       :op.oppo/update
                       :op.oppo/any-update
                       :op.oppo/move
                       :op.oppo/put-on-hold
                       :op.oppo/pass
                       :op.oppo/add-to-portfolio
                       :op.oppo/resurrect]}])

(defn toolbar-buttons
  [reloading?]
  [{:toolbar-button?  true
    :dropdown-action? true
    :ord              1
    :icon             (if reloading? "fa-sync fa-pulse" :fa-sync)
    :label            (if reloading? (loc/tr :reloading) (loc/tr :refresh))
    :primary-button?  true
    :on-select        (fn [e]
                        (swap! state assoc :reloading true)
                        (conn/send! :report/recalculate-all-reports
                                    {}
                                    (fn [resp]
                                      (let [job-id (:body resp)]
                                        (session/wait-for-entity-attribute-value! job-id
                                                                                  :job/status
                                                                                  [:job.status/finished :job.status/error]
                                                                                  (fn [_]
                                                                                    (swap! state assoc :reloading false)))))))}
   (grid-utils/preferred-landing-page-toggle {:view-id :dashboard})])

(defn expiration
  [minutes]
  (+ (int (/ (.getTime (js/Date.)) 1000)) (* 60 minutes)))

(defn component
  []
  (fn []
    (let [dashboard-report (->> @session/all-cached-reports
                                (cu/filter-by :cached-report/report-key :cached-report.type/dashboard)
                                (sort-by :common/updated-on)
                                (last))
          dashboard-data (:cached-report/value dashboard-report)
          timeline-report (->> @session/all-cached-reports
                               (cu/filter-by :cached-report/report-key :cached-report.type/dashboard-timeline)
                               (sort-by :common/updated-on)
                               (last))
          timeline-entries (:cached-report/value timeline-report)]
      [:<>
       [zap-toolbar/view state
        (fn []
          (when-not (or (nil? (:common/updated-on dashboard-report))
                        (= 0 (:common/updated-on dashboard-report)))
            [:span.last-update
             (loc/tr :dashboard-label [(session/long->tenant-date-time (:common/updated-on dashboard-report))])]))
        nil
        (toolbar-buttons (:reloading @state))]
       [:div.entity__container.py-3
        [:div.container
         [:div.grid.grid-cols-10.gap-4
          [:div
           {:class "col-span-10 md:col-span-6"}
           [dashboard dashboard-data]]
          (when (not (tenant-customizations/capman?))
            [:div
             {:class "dashboard-timeline__container col-span-10 md:col-span-4"}
             [sidebar
              (or timeline-entries
                  [])]])]]]])))

(defmethod routing/render-view :dashboard
  [_]
  (when (or (session/old-dashboards?)
            (not (session/metabase-dashboards?)))
    [default-page-layout/view
     [component]]))
